import { render, staticRenderFns } from "./knowYourProduct.vue?vue&type=template&id=bd9dfc70&"
import script from "./knowYourProduct.vue?vue&type=script&lang=js&"
export * from "./knowYourProduct.vue?vue&type=script&lang=js&"
import style0 from "./knowYourProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports